import { render, staticRenderFns } from "./payment-page-countdown.vue?vue&type=template&id=6fb86602&scoped=true"
import script from "./payment-page-countdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./payment-page-countdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./payment-page-countdown.vue?vue&type=style&index=0&id=6fb86602&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb86602",
  null
  
)

export default component.exports